<script setup>
const props = defineProps({
    sponsors: {
        type: Array,
        required: true,
    },
});

const firstSponsor = computed(() => {
    return props.sponsors?.find((sponsor) => sponsor?.sponsor_logo?.length > 0);
});
</script>

<template>
    <div v-if="firstSponsor" class="sponsored-by fs-15">
        <div class="logo">
            <MessImage :src="firstSponsor.sponsor_logo[0].url" :alt="firstSponsor.name + ' logo'" class="background" />
        </div>
    </div>
</template>

<style>
.sponsored-by {
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.01875rem;
}

@media (min-width: 1024px) {
    .sponsored-by {
        display: flex;
        flex-wrap: wrap;
        align-items: start;
        gap: 2rem;
        margin-bottom: 2rem;
    }
}

.sponsored-by .mess-image {
    max-width: 8.8125rem;
    background: white;
    border-radius: var(--radius);
    height: auto;
    aspect-ratio: 141 / 91;
}

.sponsored-by .mess-image picture img {
    max-width: 8rem;
    width: 100%;
    object-fit: contain;
    object-position: left;
    aspect-ratio: 141 / 91;
}
</style>
